import { render, staticRenderFns } from "./ChannelDetailModal.vue?vue&type=template&id=b8409874&scoped=true&"
import script from "./ChannelDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChannelDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDetailModal.vue?vue&type=style&index=0&id=b8409874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8409874",
  null
  
)

export default component.exports